import { render, staticRenderFns } from "./CardsErrorTrue.vue?vue&type=template&id=49f56808&scoped=true&"
import script from "./CardsErrorTrue.vue?vue&type=script&lang=js&"
export * from "./CardsErrorTrue.vue?vue&type=script&lang=js&"
import style0 from "./CardsErrorTrue.vue?vue&type=style&index=0&id=49f56808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f56808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VImg})
